// Angular modules
import { NgIf }             from '@angular/common';
import { Component }        from '@angular/core';
import { OnInit }           from '@angular/core';
import { RouterOutlet }     from '@angular/router';

// Services
import { StoreService }     from '@services/store.service';

// Components
import { ToastComponent }   from '@blocks/toast/toast.component';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { ThemeService } from '@services/theme.service';

@Component({
  selector: 'body[root]',
  templateUrl : './app.component.html',
  styleUrls   : ['./app.component.scss'],
  standalone  : true,
  imports     : [RouterOutlet, ToastComponent, LoadingBarModule]
})
export class AppComponent implements OnInit
{
  constructor
  (
    public storeService : StoreService,
    private themeService: ThemeService
  )
  {
  }

  // -------------------------------------------------------------------------------
  // NOTE Init ---------------------------------------------------------------------
  // -------------------------------------------------------------------------------

  public ngOnInit() : void
  {
  }

  // -------------------------------------------------------------------------------
  // NOTE Actions ------------------------------------------------------------------
  // -------------------------------------------------------------------------------

  // -------------------------------------------------------------------------------
  // NOTE Computed props -----------------------------------------------------------
  // -------------------------------------------------------------------------------

  // -------------------------------------------------------------------------------
  // NOTE Helpers ------------------------------------------------------------------
  // -------------------------------------------------------------------------------

  // -------------------------------------------------------------------------------
  // NOTE Requests -----------------------------------------------------------------
  // -------------------------------------------------------------------------------

  // -------------------------------------------------------------------------------
  // NOTE Subscriptions ------------------------------------------------------------
  // -------------------------------------------------------------------------------
}
